
// ============================================================
// Fix: Interceptar /cart/add.js de Insider → usar CartAPI
// ============================================================
(function() {
// Tracking add_to_cart para Web Pixels (definición única compartida en window).
// Ver explicación completa en js-product-template.js.
if (typeof window.anPublishAddToCart !== "function") {
  window.anPublishAddToCart = function (opts) {
    try {
      opts = opts || {};
      if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== "function") {
        console.warn("[Tracking] Shopify.analytics.publish no disponible; add_to_cart no emitido para variant", opts.variantId);
        return;
      }
      var priceMinor = parseFloat(opts.price);
      var amount = isNaN(priceMinor) ? 0 : priceMinor / 100;
      var qty = parseInt(opts.quantity, 10) || 1;
      // Evento CUSTOM con prefijo (Shopify bloquea publicar eventos estándar desde el tema).
      Shopify.analytics.publish("allnutrition:add_to_cart", {
        cartLine: {
          quantity: qty,
          cost: {
            totalAmount: { amount: (amount * qty).toFixed(2), currencyCode: "CLP" }
          },
          merchandise: {
            id: "gid://shopify/ProductVariant/" + opts.variantId,
            title: opts.title || "",
            sku: opts.sku || "",
            price: { amount: amount.toFixed(2), currencyCode: "CLP" },
            product: {
              id: opts.productId ? "gid://shopify/Product/" + opts.productId : "",
              title: opts.title || "",
              type: opts.productType || "",
              vendor: opts.vendor || "",
              url: opts.url || window.location.pathname
            }
          }
        }
      });
    } catch (e) {
      console.warn("[Tracking] analytics.publish falló:", e);
    }
  };
}

// Esperar a que CartAPI esté disponible
function waitForCartAPI(callback) {
    if (window.CartAPI && typeof window.CartAPI.addOrUpdateItems === 'function') {
    callback();
    } else {
    setTimeout(() => waitForCartAPI(callback), 100);
    }
}

waitForCartAPI(function() {
    // Interceptar XMLHttpRequest para capturar llamadas a /cart/add.js
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._cartInterceptUrl = url;
    this._cartInterceptMethod = method;
    return originalOpen.apply(this, [method, url, ...rest]);
    };

    XMLHttpRequest.prototype.send = function(body) {
    // Interceptar POST a /cart/add.js (que usa Insider)
    if (
        this._cartInterceptMethod &&
        this._cartInterceptMethod.toUpperCase() === 'POST' &&
        this._cartInterceptUrl &&
        this._cartInterceptUrl.includes('/cart/add')
    ) {
        // Parsear el body (puede ser JSON o FormData/URLSearchParams)
        let variantId = null;
        let quantity = 1;
        let attributes = [];

        try {
        // Intentar como JSON
        const parsed = JSON.parse(body);
        variantId = parsed.id || (parsed.items && parsed.items[0] && parsed.items[0].id);
        quantity = parsed.quantity || (parsed.items && parsed.items[0] && parsed.items[0].quantity) || 1;

        // Convertir properties a attributes si existen
        if (parsed.properties) {
            attributes = Object.entries(parsed.properties).map(([key, value]) => ({ key, value: String(value) }));
        }
        } catch (e) {
        // Intentar como URLSearchParams
        try {
            const params = new URLSearchParams(body);
            variantId = params.get('id');
            quantity = parseInt(params.get('quantity')) || 1;
        } catch (e2) {
            console.warn('[CartFix] No se pudo parsear body de /cart/add.js:', body);
        }
        }

        if (variantId) {
        console.log('[CartFix] Interceptando /cart/add.js → CartAPI. Variant:', variantId, 'Qty:', quantity);

        // Redirigir al CartAPI del Storefront API
        window.CartAPI.addOrUpdateItems([{
            merchandiseId: 'gid://shopify/ProductVariant/' + variantId,
            quantity: quantity,
            attributes: attributes
        }]).then(() => {
            // Tracking: republicar add_to_cart para Web Pixels (recomendaciones de Insider).
            // Aquí solo disponemos de variantId y quantity desde el body interceptado.
            window.anPublishAddToCart({ variantId: variantId, quantity: quantity });

            // Disparar evento que actualiza el minicart
            document.dispatchEvent(new CustomEvent('storefront:cart:updated', {
            detail: { cart: window.CartAPI.cartData }
            }));
            // Actualizar contadores del carrito
            if (window.CartAPI.cartData) {
            const qty = window.CartAPI.cartData.totalQuantity || 0;
            document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = qty);
            document.querySelectorAll('[data-cart-count-bubble]').forEach(el => el.classList.remove('d-none'));
            }
        }).catch(err => {
            console.error('[CartFix] Error al agregar al carrito:', err);
        });

        // Simular respuesta exitosa para que Insider no muestre error
        Object.defineProperty(this, 'status', { get: () => 200 });
        Object.defineProperty(this, 'responseText', { get: () => JSON.stringify({ items: [] }) });
        if (this.onreadystatechange) {
            Object.defineProperty(this, 'readyState', { get: () => 4 });
            this.onreadystatechange();
        }
        return; // NO enviar la request real
        }
    }

    // Para cualquier otra request, comportamiento normal
    return originalSend.apply(this, arguments);
    };

    console.log('[CartFix] Interceptor de /cart/add.js activado');
});
})();

